import React from 'react'

import Layout from '../components/layout'
import News from '../components/featuredNews'
import NewsSplash from '../../static/img/splash-events-2021.jpg'
var dateFormat = require('dateformat');

class NewsEventsPage extends React.Component {
     constructor(props) {
          super(props);
     }
     render() {
          let unordered = [];
          let events = [];
          this.props.data.Events.edges.map((item, index) => {
               if (item.node != null) {
                    item.node.type = 'EVENTS';
                    item.node.date = new Date(item.node.date);
                    item.node.date = dateFormat(item.node.date, 'mediumDate');
                    events.push(item);
               }
          });
          this.props.data.News.edges.map((item, index) => {
               if (item.node != null) {
                    item.node.type = 'NEWS';
                    item.node.date = new Date(item.node.date);
                    item.node.date = dateFormat(item.node.date, 'mediumDate');
                    unordered.push(item);
               }
          });
          return (
               <Layout className="news-page">
                    <div
                         className="splash jumbotron"
                         style={{ minHeight: '400px', marginBottom: '0px', backgroundImage:`url(${NewsSplash})`, backgroundSize:'cover', backgroundPosition: 'center center' }}
                    >
                         <h1 className="text-white text-center wow fadeInDown">NEWS & EVENTS</h1>
                    </div>
                    <div className="container-fluid bg-secondary pt-3 pb-3">
                         <div className="container">
                              <div className="row">
                                   <div className="col-md-4"><a href="#news" className="btn btn-lg btn-outline-info btn-block text-white ml-2 mr-2">CoFES News</a></div>
                                   <div className="col-md-4"><a href="#calendar" className="btn btn-lg btn-outline-info btn-block text-white ml-2 mr-2">Calendar of Events</a></div>
                                   <div className="col-md-4"><a href="/eubank-conferences/" className="btn btn-lg btn-outline-info btn-block text-white ml-2 mr-2">Past Events</a></div>
                              </div>
                         </div>
                    </div>
                    <div id="news" className="container-fluid container-news pt-4 pb-4">
                         <div className="container">
                              <div className="row" id="9th-eubank">
                                   <div className="col-md-12">
                                        <h2 className="text-center text-primary mt-4">CoFES News</h2>
                                   </div>
                              </div>
                              <div className="row">
                                   {unordered.length != 0 && unordered.map(function (item, index) {
                                        return (
                                             <News key={index} {...item.node}></News>
                                        );
                                   })
                                   }
                                   {unordered.length === 0 &&
                                        <p className="muted">No any Past Events!</p>
                                   }
                              </div>
                         </div>
                    </div>
                    <div id="calendar" className="container-fluid container-news pt-4 pb-4">
                         <div className="container">
                              <div className="row" id="9th-eubank">
                                   <div className="col-md-12">
                                        <h2 className="text-center text-primary mt-4">Calendar of Events</h2>
                                   </div>
                              </div>
                              <div className="row">
                              {events.length != 0 && events.map(function (item, index) {
                                   return (
                                        <News key={index} {...item.node}></News>
                                   );
                              })
                              }
                              {events.length === 0 &&
                                   <p className="muted">No events!</p>
                              }
                              </div>
                         </div>
                    </div>
               </Layout>
          );
     }
}

export const Newsquery = graphql`
 query News {
   News: allFlamelinkNewsContent(
    sort: {
      fields: [date]
      order: DESC
    }
  ) {
     edges {
       node {
         id,
         title,
         shortDescription,
         details,
         thumbnail {
           contentType
           file
           folderId
           type
           url
           flamelink_id
         },
         date
       }
     }
},
Events: allFlamelinkCalendarOfEventsContent(
    sort: {
      fields: [date]
      order: DESC
    }
  ) {
   edges {
     node {
       id,
       title,
       shortDescription,
       details,
       date
     }
   }
}
}
`;

export default NewsEventsPage;
